<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="form"
            :inline="true"
            :rules="rules"
            :model="listData"
            class="query-form"
            size="mini"
            style="padding: 10px 0 0 100px"
        >
            <el-form-item label="日期: " class="query-form-item" prop="dateArr">
                <el-date-picker
                    v-model="listData.dateArr"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="">
                <div>
                    <span>大词建议竞价：</span>
                    <el-input-number
                        v-model="objData.suggest_bidding"
                        style="width: 150px;margin-left:60px;"
                        :min="0.01"
                        label="请输入大词建议竞价"
                    ></el-input-number>
                </div>
                <div style="margin-top:12px;">
                    <span>目标acos（0.01 ~ 1）：</span>
                    <el-input-number
                        v-model="objData.target_acos"
                        style="width: 150px;margin-left: 8px;"
                        :min="0.01"
                        :max="1"
                        label="请输入大词建议竞价"
                    ></el-input-number>
                </div>
                <el-input
                    type="textarea"
                    style="width: 420px;margin-top:12px;"
                    :rows="8"
                    placeholder="请输入词根数据，已换行区分"
                    v-model="objData.manual_root"
                >
                </el-input>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/statistics/statistics";

export default {
    data() {
        return {
            files: [],
            dateArr: [],
            rules: {
                dateArr: [
                    {
                        required: true,
                        message: "请选择日期",
                        trigger: "blur"
                    }
                ]
            },
            listData: {},
            objData: {
                manual_root: "",
                target_acos: "",
                suggest_bidding: ""
            }
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    mounted() {
        if (this.formData.id) {
            const listData = JSON.parse(JSON.stringify(this.formData));
            listData.dateArr = [
                this.formData.start_date,
                this.formData.end_date
            ];
            this.listData = listData;
            let arr = JSON.parse(this.formData.manual_root);
            let manual_root = "";
            arr.forEach((element, index) => {
                manual_root = manual_root + element + "\n";
            });
            this.objData = {
                manual_root: manual_root,
                target_acos: this.formData.target_acos,
                suggest_bidding: this.formData.suggest_bidding
            };
        }
    },
    methods: {
        // 保存信息
        submitForm() {
            // console.log(this.objData.manual_root.split(/[(\r\n)\r\n]+/));
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (!this.listData.dateArr.length) {
                        this.$message.warning(`请选择日期`);
                        return;
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: "添加中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
					let manual_root = this.objData.manual_root.split(/[(\r\n)\r\n]+/).filter(function(s){return s && s.trim()})
					for(let i=0;i<manual_root.length;i++){
						manual_root[i] = manual_root[i].trim()
					}
                    api.add_rationality_analysis({
                        start_date: this.listData.dateArr[0],
                        end_date: this.listData.dateArr[1],
                        suggest_bidding: this.objData.suggest_bidding,
                        target_acos: this.objData.target_acos,
                        manual_root: manual_root,
                        ad_portfolio_name_id: this.$route.query
                            .ad_portfolio_name_id
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: "添加成功",
                                    type: "success"
                                });
                                this.disabled = false;
                                this.handleClose(true);
                            } else {
                                this.disabled = false;
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                        .catch(() => {
                            this.disabled = false;
                        })
                        .finally(() => {
                            loading.close();
                        });
                } else {
                    this.loading = false;
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.listData.dateArr = [];
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
